<template>
  <div
    class="our-content-area ott-platform-our-content pb-100 position-relative z-1"
  >
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div class="col-lg-6 col-xl-7">
          <div
            class="our-content-img position-relative z-2 text-center text-lg-end"
          >
            <img
              src="@/assets/images/our-content.png"
              alt="our-content"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="100"
            />
            <img
              src="@/assets/images/shape-5.png"
              class="shape shape-5 z-1"
              alt="shape"
            />
          </div>
        </div>
        <div
          class="col-lg-6 col-xl-5"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="our-content position-relative z-1">
            <h2 class="text-white">المزيد لتشاهده معنا</h2>
            <p class="text-silver">
              مع مجموعتنا الشاملة والضخمة من القنوات التلفزيونية، لن تفوتك مبارياتك الرياضية المفضلة أو برامجك المفضلة بعد الآن. كن أول من يتابع الحلقات الجديدة والحصرية فور صدورها.
            </p>
            <p>
              <span class="text-white"
                >شاهد القنوات الرياضية الحصرية كل أسبوع. احصل على دعم فني متميز مخصص لخدمة العملاء على مدار الساعة، واجمع كل خدماتك المفضلة في اشتراك واحد.</span
              >
            </p>
            <ul class="ps-0 list-unstyled content-list">
              <li class="d-flex align-items-center">
                <i class="ti ti-circle-check"></i>
                <span>أكثر من 25,000 قناة عالمية بجودة 4K</span>
              </li>
              <li class="d-flex align-items-center">
                <i class="ti ti-circle-check"></i>
                <span>مكتبة ضخمة تضم آلاف الأفلام والمسلسلات الحديثة والكلاسيكية</span>
              </li>
            </ul>
            <RouterLink to="/about-us" class="btn">
              <span class="border-style">عرض قائمة القنوات</span>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MoreToStream",
});
</script>